<template>
  <div>
    <the-header />

    <div>
      <transition name="fade" mode="out-in">
        <router-view class="router-view" />
      </transition>
    </div>
  </div>
</template>

<script>
import TheHeader from './components/TheHeader'
import { mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'App',

  components: {
    TheHeader
  },

  beforeCreate() {
    this.$store.dispatch('validateSession')
  },
  created() {
    window.addEventListener('beforeunload', this.handler)
  },
  // beforeDestroy() {
  //   window.removeEventListener('unload', this.handler)
  // },

  methods: {
    ...mapActions(['validateSession']),
    handler: function(event) {
      sessionStorage.setItem('refreshRoute', this.$route.path)
    }
  }
}
</script>

<style lang="scss">
@import './sass/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue